const baseUrl = ''; // 'http://localhost:7777';

export const getMenuByType = (tenantId, userId, type, page, pageSize, parameters) => {
  return `${baseUrl}/InventoryService/menu/tenant/${tenantId}/user/${userId}/type/${type.toLowerCase()}/page/${page}/pagesize/${pageSize}/list?${parameters}`;
};

export const getMenuByTypeAndProductId = (tenantId, userId, type, productId, parameters) => `${baseUrl}/InventoryService/menu/tenant/${tenantId}/user/${userId}/type/${type}/product/${productId}/list?${parameters}`;

export const getMenuAll = (tenantId, userId) => `${baseUrl}/InventoryService/menu/tenant/${tenantId}/user/${userId}/all`;

export const searchMenu = () => `${baseUrl}/InventoryService/menu/search`;

export const searchSuggestions = (searchTerm, customerType, pageSize) => `${baseUrl}/InventoryService/menu/searchSuggestions?${encodeURI(`searchTerm=${searchTerm}&customerType=${customerType}&page_size=${pageSize}`)}`;

export const searchProducts = (searchTerm, customerType, pageSize) => `${baseUrl}/InventoryService/menu/searchProducts?${encodeURI(`searchTerm=${searchTerm}&customerType=${customerType}&page_size=${pageSize}`)}`;

export const isSuccessResultCode = (responseData) => {
  return responseData && responseData.resultCode && responseData.resultCode === 'SUCCESS';
};

export const isFailResultCode = (responseData) => {
  return responseData && responseData.resultCode && responseData.resultCode === 'FAIL';
};



// WEBPACK FOOTER //
// ./src/helpers/api.js